import React from 'react';
import { ThemeProvider as StyledThemeProvider, DefaultTheme } from 'styled-components';

const ThemeProvider = ({ theme, children }: { theme: DefaultTheme; children: React.ReactNode }) => (
  <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
);

export default ThemeProvider;
